// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoFolhaIndex_td__kLLmX","td2":"PersonalizacaoFolhaIndex_td2__PDRp5","inscricao":"PersonalizacaoFolhaIndex_inscricao__l8cQI"};